import { useEffect, useState } from "react";
import Auth from "../../../Auth/Auth";
import { LegalInfoForm } from "./Form/LegalInfoForm";
import { DESCRIPTION_ADD_COMPANY, TITLE_ADD_COMPANY } from "./texts/EmpresaTexts";
import CompaniesService from "../../../services/CompaniesService";
import { TFormDataEmpresa, TUserIdentityRepresentantes } from "./types/EmpresaTypes";
import { GenericMessageModalWithoutButton } from "../../Modals/GenericModal";
import { Spinner, SpinnerSize } from "@fluentui/react";

const BASE_CLASS = "convenienceTestScreenAccountCompanyHolderData"

const ConvenienceTestScreenAccountCompanyHolderData = () => {
    const [response, setResponse] = useState<string>('');
    const [activeModal, setActiveModal] = useState<boolean>(false);
    const localTheme = window.localStorage.getItem("theme") || "light";
    const [loadingRepresentantes, setLoadingRepresentantes] = useState<boolean>(true);

    const [userIdentities, setUserIdentities] = useState<TUserIdentityRepresentantes[]>([]);

    const user = Auth.getUserProfile();

    const getUserIdentities = async () => {
        const userIdentitiesList: TUserIdentityRepresentantes[] = await CompaniesService.GetUserIdentitiesRepresentantesInfoByUserId(user.id);
        setUserIdentities(userIdentitiesList);
        setLoadingRepresentantes(false);
    }

    const addNewCompany = async (formData: TFormDataEmpresa) => {
        const addCompaniesResult = await CompaniesService.addCompanies(formData);
        setActiveModal(true);
        setResponse(addCompaniesResult
            ? 'El Interviniente Empresa se ha añadido con éxito.'
            : 'Ha habido un problema añadiendo al Interviniente Empresa, por favor póngase en contacto con el servicio técnico.');
    };

    useEffect(() => {
        getUserIdentities();
    }, []);

    return (
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__header`}>
                <h2 className={`${BASE_CLASS}__header__title`}>{TITLE_ADD_COMPANY}</h2>
                <p className={`${BASE_CLASS}__header__description ${localTheme}`}>{DESCRIPTION_ADD_COMPANY}</p>
            </div>
            { loadingRepresentantes
            ? <Spinner size={SpinnerSize.small} className="button-spinner" />
            : <LegalInfoForm userIdentitiesList={userIdentities} submitData={addNewCompany} /> }
            <GenericMessageModalWithoutButton title={'Proceso Interviniente Empresa'} body={response} showModal={activeModal} onClose={setActiveModal} />
        </div> 
    );
}

export default ConvenienceTestScreenAccountCompanyHolderData;